import React from 'react';
import { Backdrop, Box, CircularProgress } from '@mui/material';

const Loader = ({ isShow }: { isShow: boolean }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        mx: 'auto',
        my: 6
      }}
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress size={64} disableShrink thickness={3} />
    </Box>
    // <CircularProgress size={64} disableShrink thickness={3} />
    // <Backdrop
    //   sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    //   open={isShow}
    //   //   onClick={handleClose}
    // >
    //   <CircularProgress size={64} disableShrink thickness={3} />
    // </Backdrop>
  );
};

export default Loader;
